import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from './Button';
import styles from './ExpandButton.module.scss';

const ExpandButton = ({
  fullWidth = false,
  isActive = false,
  onClick,
  title = '',
  theme = 'light',
}) => (
  <Button
    className={classnames(styles.expandButton, {
      [styles.light]: theme === 'light',
      [styles.dark]: theme === 'dark',
      [styles.active]: isActive,
      [styles.fullWidth]: fullWidth,
    })}
    onClick={onClick}
  >
    <div className={styles.inner}>
      <span>{title}</span>
      <span className={styles.iconOuter}>
        <span className={styles.iconInner} />
      </span>
    </div>
  </Button>
);

ExpandButton.propTypes = {
  fullWidth: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
  title: PropTypes.string,
};

export default ExpandButton;
